let dd = require('ES/lib/dd');
let FormMixin = require('ES/widgets/forms/FormMixin');

module.exports = dd.createClass({
	mixins: [FormMixin],
	buildFields: function(){
		return {
			search: {
				label: 'Name to search for',
				type: 'text'
			}
		};
	},
	render: function(){
		let fields = this.buildFields();
		let errors = this.state.errors || {};
		let error = errors['search'];

		return dd.form({onSubmit: this._form_onSubmit},
			dd.div({className: error ? ' has-error' : null},
				dd.label(null, fields.search.label),
				dd.div({className: 'input-group'},
					this._form_buildInput(fields.search, 'search'),
					dd.span({className: 'input-group-btn'},
						dd.button({className: 'btn btn-default pull-left', type: 'submit'}, dd.i({className: 'fa fa-search'}))
					)
				),
				error ? dd.span({className: 'help-block'}, error) : null
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/contacts/ContactGrabber/SearchForm.js